import React, { Component } from 'react';
import { initConfigurator } from '../modules/config';
import { Button, Progress } from 'semantic-ui-react';
import { createOrder } from '../modules/helper';
import Modal from './Modal';

const buttonStyle = {
  float: 'left',
  width: '45%',
};

export default class Bottons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processPercent: undefined,
      open: false,
    };
    this.options = [
      { value: 'email', label: 'email' },
      { value: 'notes', label: 'notes' },
    ];
  }

  onResetConfig = () => {
    const { api, initConfig } = this.props;
    api.configuration.setConfiguration(initConfig);
  };

  closeModal = () => {
    this.setState({ open: false });
  };

  openModal = () => {
    this.setState({ open: true });
  };

  onDownloadSpecs = customerState => {
    const { email, notes } = customerState;
    const { product, api } = this.props;
    const configuration = api ? api.configuration.getConfiguration() : {};
    const attr = {
      sceneId: product.sceneId,
      productName: product.name,
      productId: product.productId,
      configuration,
      customer: {
        notes,
        email,
      },
      metadata: {
        shareLink: `${window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname}?configuration=${JSON.stringify(
          configuration
        ).replace('&', 'ANDPLACEHOLDER')}`,
      },
    };

    createOrder(attr, 'share').then(response => {
      console.log('----------', response && response.shortenUrl);
    });

    this.setState({
      processPercent: 1,
    });

    product.pdf && product.pdf(api, attr, this.setState.bind(this));
  };

  render() {
    const { processPercent, open } = this.state;
    const { initConfig } = this.props;
    const buttons = (
      <div>
        {' '}<Button style={buttonStyle} onClick={this.openModal}>
          {' '}Download Specs{' '}
        </Button>{' '}
        {initConfig &&
          <Button style={buttonStyle} onClick={this.onResetConfig}>
            Reset Configuration{' '}
          </Button>}{' '}
      </div>
    );

    return (
      <div className="container button-container">
        {processPercent
          ? <Progress percent={processPercent} indicating>
              Processing SPEC Sheet{' '}
            </Progress>
          : <div>
              {buttons}{' '}
            </div>}
        <Modal
          actionFn={this.onDownloadSpecs}
          closeModal={this.closeModal}
          options={this.options}
          open={open}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Bottons.js